import { ValidateJSModel, BranchCollectionItemModel } from 'forms/shared/types';

const branchCollectionItemModelValidator: ValidateJSModel<BranchCollectionItemModel> = {
  Has: () => ({
    hasValue: true,
  }),
};

export default branchCollectionItemModelValidator;
